/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CommentIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "comment", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M7.5 16.5H9.5V20.5L13.5 16.5H17.5C18.6046 16.5 19.5 15.6046 19.5 14.5V8.5C19.5 7.39543 18.6046 6.5 17.5 6.5H7.5C6.39543 6.5 5.5 7.39543 5.5 8.5V14.5C5.5 15.6046 6.39543 16.5 7.5 16.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CommentIcon);
export default ForwardRef;
//# sourceMappingURL=commentIcon.js.map